var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1320_8705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9565 5.19555H8.42102C8.57753 5.03166 8.67386 4.80976 8.67386 4.56523C8.67386 4.06098 8.26507 3.65219 7.76083 3.65219C7.44315 3.65219 7.1635 3.8145 6.99996 4.06063C6.83642 3.8145 6.55675 3.65219 6.23909 3.65219C5.73485 3.65219 5.32606 4.06098 5.32606 4.56523C5.32606 4.80976 5.42239 5.03168 5.57891 5.19555H3.04346C3.04346 5.86791 3.62908 6.41293 4.30138 6.41293H4.2608C4.2608 7.08531 4.80584 7.63035 5.47823 7.63035C5.47823 7.84812 5.53562 8.05227 5.63581 8.22902L4.626 9.23885L5.40076 10.0136L6.49976 8.91458C6.5428 8.93036 6.58734 8.94302 6.63334 8.95163L5.96924 10.451L6.99996 11.5652L8.03068 10.451L7.36659 8.95158C7.41261 8.94296 7.45712 8.93033 7.50016 8.91452L8.59916 10.0135L9.37392 9.23877L8.36409 8.22893C8.4643 8.05221 8.5217 7.84804 8.5217 7.63027C9.19405 7.63027 9.73909 7.08525 9.73909 6.41284H9.69854C10.3708 6.4129 10.9565 5.86791 10.9565 5.19555Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1320_8705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAll);
export default __webpack_public_path__ + "static/media/All.f1a5d3970c08c9ca978484d23826974b.svg";
export { ForwardRef as ReactComponent };